import { render } from "./DirPickMpio.vue?vue&type=template&id=da33b8f4"
import script from "./DirPickMpio.vue?vue&type=script&lang=ts"
export * from "./DirPickMpio.vue?vue&type=script&lang=ts"
script.render = render

export default script